import React, { useState, useEffect } from "react";
import { IoBagHandle } from "react-icons/io5";
import { FiTrash2 } from "react-icons/fi";
import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";
import {
  getCart,
  updateCartItem,
  removeCartItem,
  checkoutCart,
} from "../../api/cartApi";
import { useLocation,useNavigate  } from "react-router-dom";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";

// Example options
const availableSizes = ["7", "8", "9", "10", "11", "12", "48"];
const availableColors = ["Blue", "Black", "Red", "White"];

const OrderReviewPage = () => {
  const [products, setProducts] = useState([
    {
      id: 1,
      name: "CRI TRIUMPH Cricket Shoes For Men",
      image: "/image/shoeimg.png",
      originalPrice: 180,
      discountedPrice: 145,
      quantity: 1,
      size: "",
      color: "",
    },
    {
      id: 2,
      name: "CRI TRIUMPH Cricket Shoes For Men",
      image: "/image/shoeimg.png",
      originalPrice: 180,
      discountedPrice: 145,
      quantity: 1,
      size: "",
      color: "",
    },
    {
      id: 3,
      name: "CRI TRIUMPH Cricket Shoes For Men",
      image: "/image/shoeimg.png",
      originalPrice: 180,
      discountedPrice: 145,
      quantity: 1,
      size: "",
      color: "",
    },
  ]);
  const [loading, setLoading] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [orderData, setOrderData] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
// Stripe hooks (same pattern used in donation.js)
  const stripe = useStripe();
  const elements = useElements();
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [payLoading, setPayLoading] = useState(false);

  useEffect(() => {
    let mounted = true;
    async function load() {
      setLoading(true);
      try {
        const res = await getCart();
        const items =
          res?.cart_items ||
          res?.cartItems ||
          res?.items ||
          res?.result?.cart_items ||
          [];
        if (mounted) setCartItems(Array.isArray(items) ? items : []);
      } catch (err) {
        console.error("Failed to load cart:", err);
      } finally {
        if (mounted) setLoading(false);
      }
    }
    load();
    return () => (mounted = false);
  }, []);
  useEffect(() => {
    // ✅ Get checkout API response and shipping info passed from previous page
    const checkoutData = location.state?.checkoutResponse;
    const addressData = location.state?.shippingAddress;

    // if (checkoutData?.success && checkoutData?.result) {
    //   setOrderData(checkoutData.result);
    // }
    if (checkoutData) {
    setOrderData(checkoutData); // <-- FIXED
  }
    if (addressData) {
      setShippingAddress(addressData);
    }
  }, [location.state]);

  // if (!orderData) {
  //   return (
  //     <div className="p-6 text-center text-gray-500">
  //       Loading order details...
  //     </div>
  //   );
  // }
  const order = orderData?.orders?.[0];
  const subtotal = order?.pricing?.total_price || 0;
  const delivery = order?.pricing?.delivery_charges || 0;
  const tax = order?.pricing?.tax_amount || 0;
  const total = orderData?.total_amount || 0;

   // --- Stripe payment handler (mirrors the donation.js logic) ---
  const handlePayNow = async (e) => {
    e?.preventDefault?.();
    // If user chose wallet or backend already processed payment, you may skip Stripe.
    // We'll check for a client_secret or requires_action to know if Stripe is required.
    try {
      setPaymentStatus(null);
      setPayLoading(true);

      // ensure stripe & elements loaded
      if (!stripe || !elements) {
        setPaymentStatus("Stripe has not loaded. Please try again later.");
        setPayLoading(false);
        return;
      }

      // We expect checkout response to contain either:
      // - client_secret (when a PaymentIntent was created) and maybe requires_action true
      // - or payment already confirmed by wallet and no client_secret
      const clientSecret =
        orderData?.client_secret ||
        orderData?.payment_intent_client_secret ||
        orderData?.payment_intent?.client_secret;

      // If there's no client secret and the backend indicates success, just navigate or show success
      if (!clientSecret) {
        // Possibly the payment was done by "wallet" or backend. Navigate to orders or show success.
        // If the backend returned orders, show them; else ask user to return to orders.
        setPaymentStatus("No card payment needed. Order completed.");
        // optional: navigate to order success page
        navigate("/order-success", { state: { orderData } });
        setPayLoading(false);
        return;
      }

      // Confirm card payment with the client secret
      const cardElement = elements.getElement(CardElement);
      if (!cardElement) {
        setPaymentStatus("Please enter card details.");
        setPayLoading(false);
        return;
      }

      const result = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: cardElement,
        },
      });

      if (result.error) {
        console.error("Stripe confirm error:", result.error);
        setPaymentStatus(`Payment failed: ${result.error.message}`);
        setPayLoading(false);
        return;
      }

      // result.paymentIntent exists on success
      if (result.paymentIntent && result.paymentIntent.status === "succeeded") {
        setPaymentStatus("Payment successful!");
        // Optionally show toast, refresh cart, navigate to order summary page
        // If the backend returned order data earlier, we already have it in orderData; else fetch orders
        navigate("/orderReceipt", { state: { orderData, paymentIntent: result.paymentIntent } });
      } else {
        // If paymentIntent.status is not succeeded, still show status
        setPaymentStatus(`Payment status: ${result.paymentIntent?.status || "unknown"}`);
      }
    } catch (err) {
      console.error("Checkout payment error:", err);
      setPaymentStatus("Payment failed. Please try again.");
    } finally {
      setPayLoading(false);
    }
  };

  // Basic CardElement styling (you can adapt)
  const cardElementOptions = {
    style: {
      base: {
        fontSize: "14px",
        color: "#424770",
        "::placeholder": { color: "#aab7c4" },
      },
      invalid: {
        color: "#9e2146",
      },
    },
  };


       
  // Handler functions
  const handleChange = (i, field, value) => {
    const items = [...products];
    items[i][field] = value;
    setProducts(items);
  };

  const handleQty = (i, type) => {
    const items = [...products];
    if (type === "inc") items[i].quantity += 1;
    else if (type === "dec" && items[i].quantity > 1) items[i].quantity -= 1;
    setProducts(items);
  };

  const handleRemove = (i) => {
    const items = [...products];
    items.splice(i, 1);
    setProducts(items);
  };

  // const subtotal = products.reduce(
  //   (acc, item) => acc + item.discountedPrice * item.quantity,
  //   0
  // );

  function getItemPrice(item) {
    const priceCandidates = [
      item.price,
      item.unit_price,
      item.product_price,
      item.product?.discount_price,
      item.product?.product_price,
      item.product?.discount_price,
    ];
    for (const p of priceCandidates) {
      const n = Number(p);
      if (!Number.isNaN(n)) return n;
    }
    return 0;
  }
  function computeSubtotal() {
    return cartItems.reduce((sum, it) => {
      const qty = Number(it.quantity || it.qty || it.count) || 1;
      return sum + getItemPrice(it) * qty;
    }, 0);
  }

  return (
    <div className="dashboard w-full min-h-screen flex">
      <Leftsidebar />

      <main className="flex-1 p-6 pl-8">
        <LeftResponsivesidebar />
        <Headmenu />
        <div className="bg-white rounded-2xl p-6 w-full mx-auto shadow-sm">
          {/* Back Button */}
          <div className="mb-6">
            <button className="text-sm text-[#095228] font-semibold">
              ← BACK
            </button>
          </div>

          {/* Main Layout */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Left: Product List */}

            <div className="lg:col-span-2 space-y-4   px-3">
              <div className="space-y-4">
                <div className="space-y-1 border-2 rounded-full px-8 py-3">
                  <p className="text-xl text-[#095228] font-bold">Order No</p>
                  <p>{order?.order_number}</p>
                </div>
                <div className="space-y-1 border-2 rounded-full px-8 py-3">
                  <p className="text-xl text-[#095228] font-bold">
                    Shipping Details
                  </p>
                  {shippingAddress ? (
                    <p>
                      {shippingAddress.address_line_1}, {shippingAddress.city},{" "}
                      {shippingAddress.state}, {shippingAddress.postal_code},{" "}
                      {shippingAddress.country}.
                      <br />
                      Phone: {shippingAddress.phone}
                    </p>
                  ) : (
                    <p>No shipping address available.</p>
                  )}
                </div>
                <div className="space-y-1 border-2 rounded-full px-8 py-3">
                  <p className="text-xl text-[#095228] font-bold">
                    Delivery Details
                  </p>
                  {shippingAddress ? (
                    <p>
                      {shippingAddress.address_line_1}, {shippingAddress.city},{" "}
                      {shippingAddress.state}, {shippingAddress.postal_code},{" "}
                      {shippingAddress.country}.
                      <br />
                      Phone: {shippingAddress.phone}
                    </p>
                  ) : (
                    <p>No shipping address available.</p>
                  )}
                </div>
              </div>{" "}
              {/* Ordered Products */}
              <div className="border rounded-xl mt-6">
                {order?.items?.map((item, index) => (
                  <div
                    key={index}
                    className="flex justify-between items-center p-4 border-b-2"
                  >
                    <div className="flex w-full items-center gap-4">
                      <div className="w-1/4">
                        <img
                          src="/image/shoeimg.png"
                          alt={item.product_name}
                          className="w-36 h-36 object-contain rounded-md"
                        />
                      </div>
                      <div className="w-3/4">
                        <div className="flex justify-between">
                          <h3 className="text-sm font-semibold">
                            {item.product_name}
                          </h3>
                          <button className="text-red-500 text-xl">
                            <FiTrash2 />
                          </button>
                        </div>

                        <div className="text-xs text-black font-bold mt-2">
                          <p className="w-[160px] p-2 rounded-xl border-[3px] mt-1 border-green-500 text-center">
                            {order?.seller?.name}
                          </p>
                        </div>

                        <div className="flex justify-between items-center mt-3">
                          <p className="text-sm text-gray-600">
                            Qty: {item.quantity}
                          </p>
                          <p className="font-bold text-[#095228]">
                            $
                            {orderData?.total_amount?.toFixed(2) ||
                              item.total_price}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right: Order Summary */}
            <div className="border rounded-2xl p-6 bg-white shadow-sm h-fit">
              <h3 className="text-xl font-semibold mb-4">Order Summary</h3>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span>Subtotal</span>
                  <span className="font-bold">${subtotal}</span>
                </div>
                <div className="flex justify-between">
                  <span>Tax</span>
                  <span className="font-bold">${tax}</span>
                </div>
                <div className="flex justify-between">
                  <span>Delivery</span>
                  <span className="font-bold">${delivery}</span>
                </div>
                <hr />
                <div className="flex justify-between font-bold text-lg">
                  <span>Total</span>
                  <span>${total}</span>
                </div>
              </div>
               {/* Payment UI: render CardElement for card payments */}
              <div className="mt-4">
                <label className="block text-sm font-medium mb-2">Card Details</label>
                <div className="p-3 border rounded">
                  <CardElement options={cardElementOptions} />
                </div>
              </div>

              {paymentStatus && (
                <p className="mt-3 text-sm text-red-600">{paymentStatus}</p>
              )}

              <button
                onClick={handlePayNow}
                disabled={payLoading}
                className={`mt-6 w-full ${payLoading ? "opacity-70 cursor-not-allowed" : ""} bg-[#095228] text-white py-3 rounded-lg font-semibold flex items-center justify-center gap-2`}
              >
                <IoBagHandle className="text-xl" />
                {payLoading ? "Processing…" : "Pay Now"}
              </button>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default OrderReviewPage;

//  <div
//       className="w-full max-w-[554px] min-h-[124px] bg-white border border-[#E5E5E5] rounded-[16px] shadow-sm hover:shadow-md transition-shadow p-4 flex flex-col sm:flex-row gap-4 items-center"
//       style={{
//         fontFamily:
//           'Poppins, Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial',
//       }}
//     >
//       {/* Image */}
//       <div className="flex-shrink-0 w-full sm:w-[96px] bg-gray-50 rounded-md flex items-center justify-center overflow-hidden">
//         <img
//           src={image}
//           alt={title}
//           className="w-full sm:w-[96px] sm:h-[96px] object-contain"
//         />
//       </div>

//       {/* Title + variant */}
//       <div className="flex-1 min-w-0">
//         <div className="text-sm font-medium text-gray-900 truncate">
//           {title}
//         </div>
//         {item?.variant_name && (
//           <div className="text-xs text-gray-500 mt-1 truncate">
//             {item.variant_name}
//           </div>
//         )}
//       </div>

//       {/* Price */}
//       <div className="w-[100px] text-right">
//         <div className="text-sm text-gray-700">${totalPrice.toFixed(2)}</div>
//         <div className="text-xs text-gray-400">
//           ${(Number(unitPrice) || 0).toFixed(2)} each
//         </div>
//       </div>

//       {/* Quantity selector */}
//       <div className="flex flex-col items-center gap-2">
//         <div className="flex items-center border rounded-md overflow-hidden">
//           <button
//             aria-label="decrease"
//             onClick={() => changeQty(qty - 1)}
//             className="px-3 py-1 text-sm text-white bg-[#2B4E3E] hover:opacity-90"
//           >
//             -
//           </button>
//           <div className="px-3 py-1 text-sm">{qty}</div>
//           <button
//             aria-label="increase"
//             onClick={() => changeQty(qty + 1)}
//             className="px-3 py-1 text-sm text-white bg-[#2B4E3E] hover:opacity-90"
//           >
//             +
//           </button>
//         </div>
//       </div>

//       {/* Delete */}
//       {/* Delete */}
//       <button
//         onClick={() => onRemove && onRemove(item?.id)}
//         className="text-[#E63946] ml-2 p-1"
//       >
//         <HiOutlineTrash size={18} />
//       </button>
//     </div>
